import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { VplRouter } from '../../services/vpl-router/vpl-router';
import { setCookie, getCookie } from '../../tools/functions';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';
import { CatalogCard } from '../catalog.item/catalogcard';
import { CheckboxItem } from '../catalog.smart.filter/checkboxitem';
import { showCatalogPreloader, hideCatalogPreloader  } from '../../services/preloader/preloader';
import { number_format } from '../../tools/functions';


export const CatalogViewed = {
    props: {
        structKey: [String, Number]
    },
    created(){
        // экземпляр Swiper вне data(): реактивная обёртка Vue ему не нужна
        this.swiper = null;
    },
    mounted(){
        this.initSlider();
    },
    beforeUnmount(){
        this.destroySlider();
    },
    watch: {
        // Компонент живёт в подвале и монтируется один раз при старте приложения,
        // а секция со слайдером — под v-if по списку просмотренных. Список
        // приходит с JSON каждой страницы: при первом заходе он может быть пуст
        // (слайдера ещё нет), а после SPA-перехода на товар — появиться или
        // измениться. Swiper нужно создавать заново на каждый новый состав
        // списка, иначе слайды остаются без ширины (width: 100% из CSS Swiper —
        // одна карточка на всю ленту) и без сигнала для ленивой загрузки фото.
        viewedIds(){
            this.$nextTick(() => this.initSlider());
        }
    },
    methods: {
        number_format: number_format,
        destroySlider(){
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        },
        initSlider(){
            this.destroySlider();
            if (!this.$refs.slider) {
                return;
            }
            this.swiper = new Swiper(this.$refs.slider, {
                loop: true,
                lazyPreloadPrevNext: 2,
                grabCursor: true,
                slidesPerView: 4,
                spaceBetween: 15,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: true
                },
                navigation: {
                    nextEl: this.$refs.next,
                    prevEl: this.$refs.prev
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.24,
                        spaceBetween: 8
                    },
                    576: {
                        slidesPerView: 2.4,
                        spaceBetween: 15
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 15
                    }
                }
            });
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'SITE_TEMPLATE_PATH']),
        viewedIds(){
            const list = this.templateData.viewedProducts;
            return Array.isArray(list) ? list.map(item => item.ID).join(',') : '';
        }
    },
    template: `

<section v-if="this.templateData.viewedProducts && this.templateData.viewedProducts.length > 0" class="viewed-products">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
                    Ранее просмотренные товары
                </h2>
            </div>
        </div>
        <div class="slider-buttons">
            <div ref="prev" class="swiper-button-prev slider-btn js-viewed-products-prev">
                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
            </div>
            <div ref="slider" class="swiper viewed-products__slider js-viewed-products-slider">
                <div class="swiper-wrapper">


                <div v-for="item in this.templateData.viewedProducts" class="swiper-slide">
                    <a  :href="item.DETAIL_PAGE_URL" class="viewed-products__card">
                        <div class="viewed-products__card-heading">
                            <div class="viewed-products__card-name" v-html="item.NAME">
                            </div>
                            <div class="viewed-products__card-img" :class="{'no-photo': item.IMAGE_SMALL === false}">
                                <img v-if="item.IMAGE_SMALL !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE_SMALL" :alt="item.NAME" :title="item.NAME">
                                <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                            </div>
                        </div>

                        <div v-if="item.PRICE.PRICE" class="product-card__price">
                            {{ number_format(item.PRICE.PRICE, 0, '.', ' ') }} ₽
                            <div v-if="item.PRICE.PRICE != item.PRICE.BASE_PRICE" class="product-card__price-old">
                                <span>{{ number_format(parseInt(item.PRICE.BASE_PRICE), 0, '.', ' ') }} ₽ </span>
                                <div v-if="item.PRICE.PERCENT" class="product-card__price-discount">{{item.PRICE.PERCENT}}%</div>
                            </div>
                        </div>

                    </a>
                </div>


                </div>
            </div>
            <div ref="next" class="swiper-button-next slider-btn js-viewed-products-next">
                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
            </div>
        </div>
    </div>
</section>
    `
}